import * as sliderItems from './slider-items.json';
import initialize from './slider';

document.addEventListener('DOMContentLoaded', initialize(sliderItems));